<template>
    <div>
      <!--<b-form-radio-group
                          buttons
                          v-bind:value="value"
                          v-on:input="$emit('input', $event)"
                          :options="options"
                           />-->
      <b-alert v-if="!value" id='scope-reminder' variant="warning" show>{{alert}}</b-alert>
      <b-button-group>
        <!-- <b-button :class="{active: value === 'custom_after'}" v-on:click="$emit('input', 'custom_before')">Custom AOI</b-button> -->
        <b-button :class="{active: value === 'current'}" v-on:click="$emit('input', 'current')">Current view</b-button>
        <b-button :class="{active: value === 'whole'}" v-on:click="$emit('input', 'whole')">Whole workpack</b-button>
      </b-button-group>
    </div>
</template>

<script>
  export default {
    name: 'ScopeInput',
    data () {
      return {

      }
    },
    props: {
      value: {
        default: null
      },
      alert: {
        default: "Please set scope to enter designatron",
        type: String
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/designotron/ScopeInput.vue